import styles from './FJImageEnhancerRight.module.less';
import PropTypes from 'prop-types';
import FJDragBox from '../../../common/components/FJDragBox/FJDragBox';
import FJImageEnhancerCreationsContainer from '../FJImageEnhancerCreations/FJImageEnhancerCreationsContainer';
import FJLocalStore from '../../../store/FJLocalStore';
import FJUtil from '../../../util/FJUtil';
import classNames from 'classnames';
import FJDisplayHeaderContainer from '../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer';
import FJHistoryPanelContainer from '../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer';
import FJImageEnhancerHeaderButtons from './FJImageEnhancerHeaderButtons.jsx';
import FJButton, { FJButtonType } from '../../../common/components/FJButton/FJButton.jsx';
import DownloadIcon from '../../../assets/svg/download_black.svg?react';
import FJConstant from '../../../constants/FJConstant.js';

const FJImageEnhancerRight = props => {
    const {
        headerTabIndex,
        uploadImg,
        setIsDraggingFile,
        taskStatus,
        imageEnhancerCreationList,
        downloadAll,
        batchDownloadLoading,
    } = props;

    const renderDownload = () => {
        if (FJUtil.isGeneratingStatus(taskStatus) || headerTabIndex !== FJConstant.CREATIONS) return null;
        // 在独立AI工具页，如果只有一个图片，则不显示下载按钮
        if (!window.isEditPage && imageEnhancerCreationList.length <= 1) return null;

        if (window.isEditPage) return <FJImageEnhancerHeaderButtons />;
        return (
            <div className={styles.download_box}>
                <FJButton
                    onClick={downloadAll}
                    className={classNames(styles.download_all, batchDownloadLoading && styles.loading)}
                    textClassName={styles.download_text}
                    text={FJLocalStore._('download-all')}
                    isLoading={batchDownloadLoading}
                    type={FJButtonType.GRADIENT}
                    icon={<DownloadIcon className={styles.download_icon} />}
                />
            </div>
        );
    };
    return (
        <FJDragBox
            multipleUpload={true}
            setIsDragging={setIsDraggingFile}
            uploadFile={uploadImg}
            disable={FJUtil.isGeneratingStatus(taskStatus)}
            className={classNames(styles.app_right)}
        >
            <FJDisplayHeaderContainer rightChildren={renderDownload()} />

            <FJImageEnhancerCreationsContainer active={headerTabIndex === FJConstant.CREATIONS} />

            <FJHistoryPanelContainer activeHeaderTabIndex={FJConstant.HISTORY} />
        </FJDragBox>
    );
};
FJImageEnhancerRight.propTypes = {
    headerTabIndex: PropTypes.string,
    uploadImg: PropTypes.func,
    setIsDraggingFile: PropTypes.func,
    imageEnhancerCreationList: PropTypes.array,
    taskStatus: PropTypes.string,
    downloadAll: PropTypes.func,
    batchDownloadLoading: PropTypes.bool,
};
export default FJImageEnhancerRight;
